const SITE_ORIGIN = "https://www.linxsystems.com";
const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
const WEBSITE_ID = `${SITE_ORIGIN}/#website`;
const CONTACT_POINT_ID = `${SITE_ORIGIN}/#contact-point`;

const brands = [
    {
        id: `${SITE_ORIGIN}/#brand-harvestpay`,
        type: "Brand",
        name: "HarvestPay",
        description: "Payments and workforce operations built for agriculture.",
        url: "https://geoagsolutions.com/what-we-do/",
    },
    {
        id: "https://www.whereo.com/#organization",
        type: ["Organization", "Brand"],
        name: "Whereo",
        description: "Smarter travel discovery shaped around where you want to be.",
        url: "https://www.whereo.com/",
        parentOrganization: true,
    },
    {
        id: `${SITE_ORIGIN}/#brand-the-luxury-schema`,
        type: "Brand",
        name: "The Luxury Schema",
        description: "Structured intelligence for exceptional luxury travel.",
    },
    {
        id: `${SITE_ORIGIN}/#brand-tennisways`,
        type: "Brand",
        name: "TennisWays",
        description: "Tools that help tennis events reach and grow their audience.",
    },
    {
        id: `${SITE_ORIGIN}/#brand-tasteiq`,
        type: "Brand",
        name: "TasteIQ",
    },
];

const services = [
    {
        slug: "consulting",
        name: "Innovation Strategy Consulting",
        serviceType: "Consulting",
        description:
            "Innovation strategy assessment, market and research validation, ideation process evaluation, and measurable calls to action.",
    },
    {
        slug: "design-and-prototype",
        name: "Design & Prototype",
        serviceType: "Design and prototyping",
        description:
            "Discovery evaluation, product validation, proof-of-concept development, prototyping, and portfolio refinement.",
    },
    {
        slug: "development",
        name: "Software Development",
        serviceType: "Software development",
        description:
            "AI solutions, mobile and web apps, database architecture, API and UI/UX design, and embedded software and hardware.",
    },
];

const caseStudies = [
    {
        slug: "john-deere-mobile-farm-manager",
        client: "John Deere",
        name: "Setting the standard for excellence, early and often.",
        problem:
            "John Deere recognized the need for a presence in the mobile app space and needed an app faster than they could produce.",
        solution: "Linx Systems developed Mobile Farm Manager, which became John Deere's first North American mobile app.",
        outcome:
            "Mobile Farm Manager won an AE50 award and became one of the five most downloaded agriculture and farming apps in the world upon introduction.",
    },
    {
        slug: "basf-grow-smart-live",
        client: "BASF",
        name: "Helping the agchem industry sell its story.",
        problem: "BASF needed to highlight the superior agronomics and economics of its US Crop Protection products.",
        solution:
            "Linx Systems worked with BASF Technical Services and Marketing divisions to refine digital strategy and develop Grow Smart Live.",
        outcome:
            "Grow Smart Live became a digital hub for BASF in the US, allowing farmers, retailers, and BASF representatives to interact and find solutions to agronomic challenges.",
    },
];

const routes = [
    {
        path: "/",
        component: "home",
        pageType: "WebPage",
        title: "Linx Systems | Innovation Strategy & Software Development",
        description:
            "Linx Systems turns ambitious ideas into practical digital products through innovation consulting, design, prototyping, and software development.",
        imageAsset: "scene-01-the-connection.png",
        imageAlt: "A Linx connection icon joining organic energy with digital systems",
        graph: "home",
        index: true,
    },
    {
        path: "/about",
        component: "about",
        pageType: "AboutPage",
        title: "About | Linx Systems",
        description:
            "Learn about Linx Systems, a practical, people-first innovation and software team founded in 1998 with roots in agriculture.",
        imageAsset: "scene-02-ideas-begin-with-people.png",
        imageAlt: "People and ideas connected in the Linx Systems visual world",
        graph: "about",
        index: true,
    },
    {
        path: "/services",
        component: "services",
        pageType: "CollectionPage",
        title: "Services | Linx Systems",
        description:
            "Explore Linx Systems consulting, design, prototyping, and software development services for practical digital innovation.",
        imageAsset: "scene-03-consulting-find-the-right-path.png",
        imageAlt: "Leaders evaluating paths through a connected innovation landscape",
        graph: "services",
        index: true,
    },
    {
        path: "/work",
        component: "work",
        pageType: "CollectionPage",
        title: "Work | Linx Systems",
        description:
            "See how Linx Systems has turned strategy into practical digital products through selected historical work for John Deere and BASF.",
        imageAsset: "scene-06-proof-in-the-field.png",
        imageAlt: "Digital products creating measurable impact in the field",
        graph: "work",
        index: true,
    },
    {
        path: "/ventures",
        component: "ventures",
        pageType: "CollectionPage",
        title: "Ventures | Linx Systems",
        description:
            "Explore self-funded Linx Systems brands spanning agriculture, travel intelligence, tennis, and other new ideas.",
        imageAsset: "scene-07-we-build-our-own-ideas.png",
        imageAlt: "A connected digital world linking Linx Systems ventures",
        graph: "ventures",
        index: true,
    },
    {
        path: "/contact",
        component: "contact",
        pageType: "ContactPage",
        title: "Contact | Linx Systems",
        description: "Contact Linx Systems to discuss an idea, product challenge, innovation strategy, or digital system.",
        imageAsset: "scene-01-the-connection.png",
        imageAlt: "A Linx connection icon joining organic energy with digital systems",
        graph: "contact",
        index: true,
    },
    {
        path: "/privacy",
        component: "privacy",
        pageType: "WebPage",
        title: "Privacy | Linx Systems",
        description: "The Linx Systems privacy page.",
        imageAsset: "scene-01-the-connection.png",
        imageAlt: "A Linx connection icon joining organic energy with digital systems",
        graph: "page",
        index: false,
    },
    {
        path: "/security",
        component: "security",
        pageType: "WebPage",
        title: "Security | Linx Systems",
        description: "The Linx Systems security page.",
        imageAsset: "scene-01-the-connection.png",
        imageAlt: "A Linx connection icon joining organic energy with digital systems",
        graph: "page",
        index: false,
    },
    {
        path: "/terms",
        component: "terms",
        pageType: "WebPage",
        title: "Terms | Linx Systems",
        description: "The Linx Systems terms page.",
        imageAsset: "scene-01-the-connection.png",
        imageAlt: "A Linx connection icon joining organic energy with digital systems",
        graph: "page",
        index: false,
    },
];

function normalizePath(pathname) {
    if (!pathname || pathname === "/") return "/";
    return pathname.replace(/\/+$/, "") || "/";
}

function getRoute(pathname) {
    const path = normalizePath(pathname);
    return routes.find((route) => route.path === path);
}

function routeUrl(path) {
    return path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;
}

function organizationNode(logoUrl) {
    return {
        "@type": ["Organization", "Corporation"],
        "@id": ORGANIZATION_ID,
        name: "Linx Systems",
        legalName: "Linx Systems Inc.",
        description:
            "Linx Systems is an innovation strategy, design, prototyping, and software development company founded in 1998.",
        url: `${SITE_ORIGIN}/`,
        foundingDate: "1998",
        logo: {
            "@type": "ImageObject",
            "@id": `${SITE_ORIGIN}/#logo`,
            url: logoUrl,
            contentUrl: logoUrl,
            caption: "Linx Systems logo",
        },
        address: {
            "@type": "PostalAddress",
            streetAddress: "25391E 1000 North Rd.",
            addressLocality: "Downs",
            addressRegion: "IL",
            postalCode: "61704",
            addressCountry: "US",
        },
        telephone: "+1-309-664-2011",
        faxNumber: "+1-309-664-2012",
        email: "linx@linxsystems.com",
        contactPoint: {
            "@id": CONTACT_POINT_ID,
        },
        sameAs: ["https://www.linkedin.com/company/linx-systems"],
        brand: brands.map((brand) => ({ "@id": brand.id })),
    };
}

function contactPointNode() {
    return {
        "@type": "ContactPoint",
        "@id": CONTACT_POINT_ID,
        contactType: "general inquiries",
        telephone: "+1-309-664-2011",
        email: "linx@linxsystems.com",
        availableLanguage: "English",
    };
}

function brandNodes() {
    return brands.map((brand) => {
        const node = {
            "@type": brand.type,
            "@id": brand.id,
            name: brand.name,
        };

        if (brand.description) node.description = brand.description;
        if (brand.url) node.url = brand.url;
        if (brand.parentOrganization) {
            node.parentOrganization = { "@id": ORGANIZATION_ID };
        }

        return node;
    });
}

function websiteNode(copyrightYear) {
    return {
        "@type": "WebSite",
        "@id": WEBSITE_ID,
        url: `${SITE_ORIGIN}/`,
        name: "Linx Systems",
        description: "The official website of Linx Systems, an innovation strategy and software development company.",
        inLanguage: "en-US",
        publisher: { "@id": ORGANIZATION_ID },
        copyrightHolder: { "@id": ORGANIZATION_ID },
        copyrightNotice: `Copyright ${copyrightYear} Linx Systems Inc. All rights reserved.`,
    };
}

function imageNode(route, pageUrl, imageUrl) {
    return {
        "@type": "ImageObject",
        "@id": `${pageUrl}#primaryimage`,
        url: imageUrl,
        contentUrl: imageUrl,
        width: 1672,
        height: 941,
        caption: route.imageAlt,
    };
}

function pageNode(route, pageUrl) {
    const node = {
        "@type": route.pageType,
        "@id": `${pageUrl}#webpage`,
        url: pageUrl,
        name: route.title,
        description: route.description,
        inLanguage: "en-US",
        isPartOf: { "@id": WEBSITE_ID },
        about: { "@id": ORGANIZATION_ID },
        publisher: { "@id": ORGANIZATION_ID },
        copyrightHolder: { "@id": ORGANIZATION_ID },
        primaryImageOfPage: { "@id": `${pageUrl}#primaryimage` },
    };

    if (route.graph === "home" || route.graph === "about") {
        node.mainEntity = { "@id": ORGANIZATION_ID };
    }
    if (route.graph === "home") {
        node.mentions = brands.map((brand) => ({ "@id": brand.id }));
    }
    if (route.graph === "services") {
        node.mainEntity = { "@id": `${pageUrl}#services` };
    }
    if (route.graph === "work") {
        node.mainEntity = { "@id": `${pageUrl}#case-studies` };
    }
    if (route.graph === "ventures") {
        node.mainEntity = { "@id": `${pageUrl}#ventures` };
    }
    if (route.graph === "contact") {
        node.mainEntity = { "@id": CONTACT_POINT_ID };
    }

    return node;
}

function serviceNodes(pageUrl) {
    const itemList = {
        "@type": "ItemList",
        "@id": `${pageUrl}#services`,
        name: "Linx Systems services",
        numberOfItems: services.length,
        itemListElement: services.map((service, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: { "@id": `${pageUrl}#service-${service.slug}` },
        })),
    };

    const nodes = services.map((service) => ({
        "@type": "Service",
        "@id": `${pageUrl}#service-${service.slug}`,
        name: service.name,
        serviceType: service.serviceType,
        description: service.description,
        url: pageUrl,
        provider: { "@id": ORGANIZATION_ID },
        mainEntityOfPage: { "@id": `${pageUrl}#webpage` },
    }));

    return [itemList, ...nodes];
}

function caseStudyNodes(pageUrl) {
    const itemList = {
        "@type": "ItemList",
        "@id": `${pageUrl}#case-studies`,
        name: "Selected Linx Systems work",
        numberOfItems: caseStudies.length,
        itemListElement: caseStudies.map((study, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: { "@id": `${pageUrl}#${study.slug}` },
        })),
    };

    const nodes = caseStudies.map((study) => ({
        "@type": "CreativeWork",
        "@id": `${pageUrl}#${study.slug}`,
        name: study.name,
        description: study.solution,
        text: `Problem: ${study.problem} Solution: ${study.solution} Outcome: ${study.outcome}`,
        isPartOf: { "@id": `${pageUrl}#webpage` },
        publisher: { "@id": ORGANIZATION_ID },
        copyrightHolder: { "@id": ORGANIZATION_ID },
        mentions: {
            "@type": "Organization",
            name: study.client,
        },
    }));

    return [itemList, ...nodes];
}

function ventureListNode(pageUrl) {
    return {
        "@type": "ItemList",
        "@id": `${pageUrl}#ventures`,
        name: "Linx Systems brands",
        numberOfItems: brands.length,
        itemListElement: brands.map((brand, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: { "@id": brand.id },
        })),
    };
}

function buildGraph(route, assets, copyrightYear) {
    const pageUrl = routeUrl(route.path);
    const graph = [
        organizationNode(assets.logo),
        contactPointNode(),
        ...brandNodes(),
        websiteNode(copyrightYear),
        imageNode(route, pageUrl, assets.image),
        pageNode(route, pageUrl),
    ];

    if (route.graph === "services") graph.push(...serviceNodes(pageUrl));
    if (route.graph === "work") graph.push(...caseStudyNodes(pageUrl));
    if (route.graph === "ventures") graph.push(ventureListNode(pageUrl));

    return {
        "@context": "https://schema.org",
        "@graph": graph,
    };
}

function buildPageMetadata(pathname, assets, copyrightYear = new Date().getFullYear()) {
    const route = getRoute(pathname);
    if (!route) return null;

    const url = routeUrl(route.path);
    return {
        title: route.title,
        description: route.description,
        robots: route.index ? "index, follow, max-image-preview:large" : "noindex, follow",
        url,
        image: assets.image,
        imageAlt: route.imageAlt,
        imageWidth: 1672,
        imageHeight: 941,
        graph: buildGraph(route, assets, copyrightYear),
    };
}

function validateSiteMetadata() {
    const errors = [];
    const paths = new Set();

    routes.forEach((route) => {
        if (paths.has(route.path)) errors.push(`Duplicate public route: ${route.path}`);
        paths.add(route.path);

        ["path", "component", "pageType", "title", "description", "imageAsset", "imageAlt", "graph"].forEach((field) => {
            if (!route[field]) errors.push(`Missing ${field} for public route: ${route.path}`);
        });

        if (typeof route.index !== "boolean") {
            errors.push(`Missing indexing decision for public route: ${route.path}`);
        }
    });

    if (!paths.has("/")) errors.push("Missing homepage metadata");

    return errors;
}

export {
    SITE_ORIGIN,
    ORGANIZATION_ID,
    WEBSITE_ID,
    routes,
    normalizePath,
    getRoute,
    routeUrl,
    buildPageMetadata,
    validateSiteMetadata,
};
